import Components from "../components";
import Honeybadger from '@honeybadger-io/js';

class HoneybadgerJS extends Components.Base {
  initialize() {
    this.config = $.parseJSON(this.$el.attr('content'));
    this.configureHoneybadger();
  }

  configureHoneybadger() {
    if (window.honeybadgerJSLoaded) { return; }
    window.honeybadgerJSLoaded = true;
    Honeybadger.configure({
      apiKey: this.config.key,
      endpoint: this.config.endpoint,
      environment: this.config.environment,
      revision: this.config.revision,
      projectRoot: "webpack:///./",
    });

    Honeybadger.beforeNotify(() => !/detectify/i.test(navigator.userAgent));

    const ignoredStacks = /chrome-extension|safari-extension|wistia|pusher|profitwell/i;
    Honeybadger.beforeNotify(notice => !ignoredStacks.test(notice.stack));

    if (this.config.user) {
      Honeybadger.setContext({
        user_id: this.config.user.id,
        user_email: this.config.user.delivery_email,
        plan: this.config.user.plan,
        channel: this.config.user.channel,
      });
    }
  }
}

Components.collection.register({
  selector: 'meta[name=i-honeybadger-js]',
  klass: HoneybadgerJS,
});

// Useful for testing in production
window.Honeybadger = Honeybadger
